import { gsap } from "@gsap";
/**
 * Layout: Progam planning
 * Slug: program_planning
 */

document.addEventListener("DOMContentLoaded", function () {
	const layouts = document.querySelectorAll(
		".flex-layout.program_planning-layout",
	);

	layouts.forEach((layout) => {
		const items = layout.querySelectorAll(".pk-accordion-item");

		items.forEach((item) => {
			var observer = new MutationObserver(function (event) {
				if(!item.classList.contains("active")) return;
				const events = item.querySelectorAll(".event");
				gsap.from(events, {
					autoAlpha: 0,
					y: -10,
					stagger: 0.1,
					delay: 0.2,
					duration: 0.2
				});
			});
			observer.observe(item, {
				attributes: true,
				attributeFilter: ["class"],
				childList: false,
				characterData: false,
			});
		});
	});
});
